import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './style.css';

import HomePage from './pages/HomePage';
import ProgramsPage from './pages/ProgramsPage';
import TrainingPage from './pages/TrainingPage';
import PracticeExamPage from './pages/PracticeExamPage';
import RequestPage from './pages/RequestPage';
import LoginPage from './pages/LoginPage';
import AdminLoginPage from './pages/AdminLoginPage';
import AdminPage from './pages/AdminPage';
import SupabaseTestPage from './pages/SupabaseTestPage';
import ExamPage from './pages/ExamPage';
import UserDashboard from './pages/UserDashboard';
import HashGeneratorPage from './pages/HashGeneratorPage';
import PremiumExamPage from './pages/PremiumExamPage';
import AddQuestionPage from './pages/AddQuestionPage';
import ManageQuestionsPage from './pages/ManageQuestionsPage';
import AdminUsersPage from './pages/AdminUsersPage';
import AddHtmlPage from './pages/AddHtmlPage';
import StaticPageView from './pages/StaticPageView';
import CLFExamPage from './pages/CLFExamPage';
import AWSSAPC02GuidePage from './pages/AWSSAPC02GuidePage';
import AWSDVAC02GuidePage from './pages/AWSDVAC02GuidePage';
import AWSSAAC03GuidePage from './pages/AWSSAAC03GuidePage';
import AWSCCPLearningHubPage from './pages/AWSCCPLearningHubPage';
import AWSCloudFundamentalsCourse from './pages/AWSCloudFundamentalsCourse';
import AWSCLFC02GuidePage from './pages/AWSCLFC02GuidePage';
import AWSCLFC02PracticePage from './pages/AWSCLFC02PracticePage';
import AWSSAPHubPage from './pages/AWSSAPHubPage';
import AWSSAPGuidePage from './pages/AWSSAPGuidePage';
import AWSSAPPracticePage from './pages/AWSSAPPracticePage';
import QuestionBankPage from './pages/QuestionBankPage';
import AdminQuestionBankPage from './pages/AdminQuestionBankPage';
import PrivateRoute from './components/PrivateRoute';

const App: React.FC = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/programs" element={<ProgramsPage />} />
      <Route path="/training" element={<TrainingPage />} />
      <Route path="/practice-exam" element={<PracticeExamPage />} />
      <Route path="/request" element={<RequestPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/admin-login" element={<AdminLoginPage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/supabase-test" element={<SupabaseTestPage />} />
      <Route path="/hash-generator" element={<HashGeneratorPage />} />
      <Route path="/exam" element={<ExamPage />} />
      <Route path="/sap-exam" element={<ExamPage defaultExam="sap" />} />
      <Route path="/aws-clf-exam" element={<CLFExamPage />} />
      <Route path="/aws-ccp" element={<AWSCCPLearningHubPage />} />
      <Route path="/aws-cloud-fundamentals-course" element={<AWSCloudFundamentalsCourse />} />
      <Route path="/aws-clf-c02-guide" element={<AWSCLFC02GuidePage />} />
      <Route path="/aws-clf-c02-practice" element={<AWSCLFC02PracticePage />} />
      <Route path="/aws-sap" element={<AWSSAPHubPage />} />
      <Route path="/aws-sap-guide" element={<AWSSAPGuidePage />} />
      <Route path="/aws-sap-practice" element={<AWSSAPPracticePage />} />
      <Route path="/aws-sap/:section" element={<Navigate to="/aws-sap-guide" replace />} />
      <Route path="/aws-sap-c02" element={<AWSSAPC02GuidePage />} />
      <Route path="/aws-dva-c02" element={<AWSDVAC02GuidePage />} />
      <Route path="/aws-saa-c03" element={<AWSSAAC03GuidePage />} />
      <Route path="/dashboard" element={<PrivateRoute><UserDashboard /></PrivateRoute>} />
      <Route path="/aws-exam-questions-saa" element={<PrivateRoute><PremiumExamPage /></PrivateRoute>} />
      <Route path="/aws-exam-questions-sap" element={<PrivateRoute><PremiumExamPage /></PrivateRoute>} />
      <Route path="/question-bank-aws-sap-c02" element={<PrivateRoute><QuestionBankPage /></PrivateRoute>} />
      <Route path="/aws-exam-questions-ccp" element={<PrivateRoute><PremiumExamPage /></PrivateRoute>} />
      <Route path="/aws-exam-questions-dva" element={<PrivateRoute><PremiumExamPage /></PrivateRoute>} />
      <Route path="/admin/add-question" element={<AddQuestionPage />} />
      <Route path="/admin/manage-questions" element={<ManageQuestionsPage />} />
      <Route path="/admin/question-bank" element={<AdminQuestionBankPage />} />
      <Route path="/admin/users" element={<AdminUsersPage />} />
      <Route path="/admin/static-pages" element={<AddHtmlPage />} />
      <Route path="/page/:slug" element={<StaticPageView />} />
      <Route path="*" element={<HomePage />} />
    </Routes>
  </BrowserRouter>
);

export default App;
